import { treeselect } from '@/api';
// 准备actions对象——响应组件中用户的动作
const actions = {
  async getTreeselect(contex) {
    const result = await treeselect();
    contex.commit('GETALL', result);
  },

};
// 准备mutations对象——修改state中的数据
const mutations = {
  GETALL(contex, val) {
    contex.homeList = val.data.slice(0, 16);
  },
};
// 准备state对象——保存具体的数据
const state = {
  homeList: [],
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
